export const CSV_HEADERS = ["Search Phrase", "Search Volume (1-4)"] as const;

export const LEVEL_LABELS = [
  "High Search Volume",
  "Above Average Search Volume",
  "Below Average Search Volume",
  "Low Search Volume",
] as const;
